<template>
  <div class="refresh-cdn-container">
    <el-card class="text-solid">
      <el-tooltip class="score-tips" effect="dark" placement="right">
        <div slot="content">
          <h6>刷新需知：括号外为腾讯云剩余次数，括号内为华为云剩余次数。</h6>
          <p><span style="color:red">*</span>1. 5分钟才能刷新一次CDN资源，一天有5次提交次数，建议一次刷新多条资源数据。</p>
          <p><span style="color:red">*</span>2. CDN刷新是一项危险操作，不得轻易刷新CDN资源且CDN刷新需要一定时间。</p>
          <p><span style="color:red">*</span>3. 可刷新以下资源类型：</p>
          <p>（1）Common： https://front-xxx-cdn.xsyx.xyz/，xxx为 xps | asset | daily | qa | grey | prod。</p>
          <p>（2）Uat： https://uat-xxx-cdn.xsyx.xyz/，xxx为 xps。</p>
          <p>（3）Combo： https://xxx-cdn.xsyx.xyz/，xxx为 uat-combo-xps | combo-xps。</p>
          <p><span style="color:red">*</span>4. 如需要更多CDN刷新的资源类型或对CDN刷新存在疑问，请联系系统管理员。</p>
        </div>
        <i class="el-icon-info" type="text"></i>
      </el-tooltip>
      <i class="grade" :title="`腾讯云还剩下 ${cdnQuota.Available} 次CDN预热次数，华为云还剩下${quotas.quota_limit - quotas.used }次CDN预热次数。`">{{cdnQuota.Available}}（{{quotas.quota_limit - quotas.used }}）</i>
      <span v-show="showWarn" class="score-desc">CDN刷新次数不足20%，已发送预警信息！</span>
    </el-card>
    <el-card>
      <el-button circle size="mini" type="success" @click="addUrlSource" icon="el-icon-plus" title="新增"></el-button>
      <el-form :model="cdnSourceForm" ref="cdnSourceForm" label-width="100px" class="demo-dynamic">
        <el-form-item v-for="(item, index) in cdnSourceForm.sources" :label="'资源' + index" :key="item.key" :prop="'sources.' + index + '.cdnPath'" :rules="cdnSourceFormRules">
          <el-input v-model="item.cdnPath" :style="{width:'85%'}"></el-input>
          <el-button :style="{padding:'0 5px',color:'red'}" type="text" icon="el-icon-delete" @click.prevent="removeSource(item)"></el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <span class="refresh-cdn-footer">
      <el-button v-show="!isDisabled" :disabled="isDisabled" type="primary" @click="submitForm('cdnSourceForm')">提交</el-button>
      <el-button v-show="isDisabled" :disabled="isDisabled" type="primary" @click="submitForm('cdnSourceForm')">{{ableTime+'s'}}</el-button>
      <el-button @click="resetForm('cdnSourceForm')">重置</el-button>
    </span>
  </div>

</template>

<script>
import { xpsApi } from '@/api';
const defaultCdnSourceForm = {
  sources: [{
    cdnPath: '',
    key: Date.now()
  }],
}
let validateCdnPath = (rule, value, callback) => {
  if (/^https\:\/\/front|uat\-xps|uat\-combo\-xps|combo\-xps|asset|daily|qa|grey|prod\-cdn\.xsyx\.xyz\//.test(value)) {
    callback()
  } else {
    callback(new Error('不支持该地址格式'))
  }
}

export default {
  props: {
    quotas: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      cdnSourceForm: JSON.parse(JSON.stringify(defaultCdnSourceForm)),
      isDisabled: false,
      ableTime: 300,
      cdnSourceFormRules: [
        {
          required: true, message: '资源地址不能为空', trigger: 'blur'
        },
        { validator: validateCdnPath, trigger: 'blur' }
      ],
      cdnQuota: {
        Available: 10000,
        Total: 10000
      },
      isShowDesc: true
    };
  },
  computed: {
    showWarn () {
      return this.isShowDesc && (this.cdnQuota.Available / this.cdnQuota.Total < 0.2) || this.quotas.used / this.quotas.quota_limit >= 0.8
    }
  },
  mounted () {
    this.getRefreshCDNQuota();
    setTimeout(() => {
      this.isShowDesc = false;
    }, 12000)
  },
  methods: {
    // 获取CDN刷新配额
    async getRefreshCDNQuota () {
      const res = await xpsApi.getRefreshCDNQuota();
      if (res.code === 200) {
        this.cdnQuota = res.data.UrlPurge[0];
      }
    },
    // 关闭对话框
    handleClose () {
      this.resetForm('cdnSourceForm');
      this.$emit('close');
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let fileList = []
          this.cdnSourceForm.sources.map((item) => {
            fileList.push(item.cdnPath.trim())
          })
          const res = await xpsApi.refreshCDN({ fileList })
          if (res.code === 200) {
            this.$emit('close');
            this.isDisabled = true
            // 定时器 限制按钮点击事件
            let timer = setInterval(() => {
              this.ableTime -= 1
            }, 1000)
            setTimeout(() => {
              clearInterval(timer)
              this.ableTime = 300
              this.isDisabled = false
            }, 5 * 60 * 1000)
            this.resetForm(formName)
            this.$message.success(res.message)
          } else {
            this.$emit('close');
            this.$message.error(res.message)
          }

        } else {
          return false;
        }
      });
    },
    // 重置表单
    resetForm (formName) {
      this.cdnSourceForm = JSON.parse(JSON.stringify(defaultCdnSourceForm))
      this.$refs[formName].resetFields();
    },
    // 移除资源
    removeSource (item) {
      if (this.cdnSourceForm.sources.length > 1) {
        var index = this.cdnSourceForm.sources.indexOf(item)
        if (index !== -1) {
          this.cdnSourceForm.sources.splice(index, 1)
        }
      } else {
        this.$message.warning('已经是最后一个资源了！无法删除哦~');
      }
    },
    // 新增资源
    addUrlSource () {
      this.cdnSourceForm.sources.push({
        value: '',
        key: Date.now()
      });
    }
  }
}
</script>

<style lang="scss">
.refresh-cdn-container {
  position: relative;
  .text-solid {
    margin-bottom: 10px;
    position: relative;
    font-size: 32px;
    text-align: center;
    font-weight: 700;
    line-height: 100px;
    text-transform: uppercase;
    background-color: #078080;
    color: #fff;
    // .grade {
    //   text-shadow: 0px 1px 0px #c0c0c0, 0px 2px 0px #b0b0b0, 0px 3px 0px #a0a0a0,
    //     0px 4px 0px #909090, 0px 5px 10px rgba(0, 0, 0, 0.6);
    // }
    .score-desc {
      position: absolute;
      font-size: 10px;
      right: 2px;
      bottom: 2px;
      line-height: 20px;
      /* Safari and Chrome播放器写法 */
      -webkit-animation-name: breath; /* 动画名称 */
      -webkit-animation-duration: 3s; /* 动画时长3秒 */
      -webkit-animation-timing-function: ease-in-out; /* 动画速度曲线：以低速开始和结束 */
      -webkit-animation-iteration-count: infinite; /* 播放次数：无限 */
    }
    .score-tips {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
  .refresh-cdn-tips {
    position: absolute;
    top: -72px;
    left: 78px;
    .tips-icon {
      color: black;
      font-size: 20px;
    }
  }
  .refresh-cdn-footer {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    width: 100%;
  }
  @keyframes breath {
    /* 动画开始时的不透明度 */
    from {
      opacity: 0.1;
    }

    /* 动画50% 时的不透明度 */
    50% {
      opacity: 1;
    }

    /* 动画结束时的不透明度 */
    to {
      opacity: 0.1;
    }
  }
}
</style>

